import PropTypes from "prop-types";
import { Paperclip } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { downloadFile } from "services/helpers";

const AttachmentsMenu = ({ attachments }) => (
  <DropdownMenu>
    <DropdownMenuTrigger
      className={buttonVariants({ variant: "outline", size: "sm" })}
    >
      <Paperclip data-icon="inline-start" />
      Attachments ({attachments.length})
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="tw:w-auto tw:max-w-sm">
      {attachments.map((attachment, index) => (
        <DropdownMenuItem
          key={attachment.id ?? index}
          onClick={() =>
            downloadFile(attachment.url, { name: attachment.file_name })
          }
        >
          <span className="tw:truncate">{attachment.file_name}</span>
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);

AttachmentsMenu.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      url: PropTypes.string,
      file_name: PropTypes.string,
    })
  ).isRequired,
};

export default AttachmentsMenu;
